// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1aNfmsyRHGBVD0MZ8-UeZB","isThemeLight":"_1pXY3LYTQN2iRPqfcm6RzC","isThemeDark":"Adwd5rEEFKRj7_jJvLHXs","description":"_359d4N8dpd3iv1YHFuLeDk"};